import http from 'common-module/src/util/http';

// 记录指引已操作信息
export async function guideRecord(step) {
  return http.post('/account/guide-record', { guideType: step });
}

// 看板筛选条件自定义字段列表
export async function loadFilterField(data) {
  return http.post('/kanban/filter/field', data);
}

// 看板事项类型对应的系统字段基础信息接口
export async function loadIssueTypeFieldInfo(data) {
  return http.post('/kanban/issue-type-basic-system-field-info', data);
}

export async function dragIssue(data) {
  return http.post('/kanban/drap', data);
}

export async function deleteKanbanIssue(issueId) {
  return http.post('/issue/delete', { issueId });
}

export async function duplicateKanbanIssue(issueId) {
  return http.post('/issue/duplicate', { issueId });
}

export async function getSprintInfo(data) {
  return http.post('/sprint/get', data);
}

export async function archivedIssue(params) {
  return http.post('/issue/archived-issue', params);
}

// 批量获取迭代信息
export async function batchGetSprintInfo(data) {
  return http.post('/sprint/batch-get-sprint-statistic', data);
}

export async function finishAssignSprint(data) {
  return http.post('/sprint/complete', data, { timeout: 30000 });
}

export async function loadAccountList(data) {
  const res = await http.post('/member/users', data);
  const projects = res.list;
  return projects.map(t => ({
    key: t.userId,
    value: t.userName,
    ...t
  }));
}

export async function saveUpdate(data) {
  return http.post('/issue/update', data);
}

export async function addKanbanColumn(data) {
  return http.post('workflow/add-state', data);
}

export async function sortColumn(data) {
  return http.post('/workflow/sort-state', data);
}

export async function addCustomField(data) {
  return http.post('/account/filter-spaces/sprintKanban/add-field', data, { showError: false });
}

export async function deleteFilter(data) {
  return http.post('/account/filter-spaces/sprintKanban/remove-field', data, { showError: false });
}

export async function editSprintCard(data) {
  return http.post('/sprint/edit', data);
}

export async function userHabitRecord(data) {
  return http.post('/account/habit-record', data);
}

export async function userHabitQuery(data) {
  return http.post('/account/habit-query', data);
}

export async function addNewSpace(data) {
  return http.post('/account/filter-spaces/sprintKanban/add', data, { showError: false });
}

export async function addSprint(data) {
  return http.post('/sprint/add', data);
}

export async function startSprint(data) {
  return http.post('/sprint/start', data);
}

export async function restartSprint(data) {
  return http.post('/sprint/restart', data);
}

export async function getSelectorsSprint(data) {
  return http.post('/sprint/project/sprint/selectors', data);
}

export async function getSubtaskStatus(projectId) {
  return http.post('/issue/subtask-status', { projectId });
}

/**
 * 获取分享信息
 * @param projectId 项目id
 * @param shareType 分享类型（kanban：看板页面分享类型）
 * @returns {Promise<*>}
 */
export const getShareInfo = async (projectId, shareType) => {
  return http.post('/info/share/fetch-info', { projectId, shareType });
};

/**
 * 创建分享链接
 * @param projectId 项目id
 * @param shareType 分享类型（kanban：看板页面分享类型）
 * @returns {Promise<*>}
 */
export const createShareLink = async (data) => {
  return http.post('/info/share/produce-info', data);
};

export const getSharedLinks = async (projectId) => {
  return http.post('/info/share/fetch-manage-info', { projectId, shareType: 'kanban' });
};

export const changeShareLinkEnable = async (shareCode, enabled) => {
  return http.post('/info/share/disable-share-link', { shareCode, enabled });
};

/**
 * 切换分享密码保护
 * @param id 分享id
 * @param projectId 项目ID
 * @param enabled 是否启用密码
 * @returns {Promise<*>}
 */
export const switchSharePassword = async (id, projectId, enabled) => {
  return http.post('/info/share/switch-pwd', { id, projectId, enabled });
};

/**
 * 获取看版事项数据
 * @param data
 * @returns {Promise<*>}
 */
export const getKanbanData = async (data) => {
  return http.post('/kanban/kanban-data', data);
};

/**
 * 获取当前用户在项目下的 Issue 可见性维度
 * @param projectId 项目 ID
 * @returns {Promise<*>}
 */
export const getCurrentUserIssueVisibility = async projectId => {
  return http.get(`/project/issue-visibility-rule/my-visibility/${projectId}`);
};

/**
 * 获取看版事项数据 新接口
 * @param data
 * @returns {Promise<*>}
 */
export const getKanbanGridData = async (data) => {
  return http.post('/kanban-grid/kanban-data', data);
};

/**
 * 保存看板筛选项
 * @param data
 * @returns {Promise<*>}
 */
export const saveKanbanGridFilter = async (data) => {
  return http.post('/kanban-grid/save-kanban-filter', data);
};

/**
 * 获取看版聚合接口数据
 * @param data
 * @returns {Promise<*>}
 */
export const loadKanbanGridAssembleInfo = async (data) => {
  return http.post('/kanban-grid/assemble-info', data, {
    abort: true,
    positionId: 'sprint'
  });
};

/**
 * 获取看版状态列数据
 * @param data
 * @returns {Promise<*>}
 */
export const getKanbanStatueColumn = async (data) => {
  return http.post('/kanban/column-info', data);
};
/**
 * 更新看板列属性
 * @param data
 * @returns {Promise<*>}
 */
export const updateKanbanColumn = async (data) => {
  return http.post('/kanban/column/update', data);
};

/**
 * 获取筛选字段选项
 * @param data
 * @returns {Promise<*>}
 */
export const getFilterFieldOption = async (data) => {
  return http.post('/account/filter-spaces/kanban/select-options', data);
};

/**
 * 获取看版聚合接口数据
 * @param data
 * @returns {Promise<*>}
 */
export const loadKanbanAssembleInfo = async (data) => {
  return http.post('/kanban/assemble-info', data, {
    abort: true,
    positionId: 'sprint'
  });
};

/**
 * 获取设置点数的选项列表
 * @param projectId 项目ID
 * @returns {Promise<*>}
 */
export const getEstimatePointOption = async (projectId) => {
  return http.post('/issue/estimate-point-option', { projectId });
};

/**
 * 创建事项
 * @param issue
 * @returns {Promise<*>}
 */
export const createIssue = async (issue) => {
  return http.post('/issue/add', issue);
};


/**
 * 创建事项
 * @param issue
 * @returns {Promise<*>}
 */
export const createIssueV2 = async (issue) => {
  return http.post('/issue/add-v2', issue);
};


/**
 * 获取看板卡片下拉选项聚合接口
 * @param data
 * @returns {Promise<*>}
 */
export const getKanbanAssembleOptions = async (data) => {
  return http.post('/kanban/select-option-assemble-info', { ...data, containAccUnEnabled: true });
};

/**
 * 获取指派人推荐列表
 * @param data
 * @returns {Promise<*>}
 */
export const getAssigneeRecommendList = async data => {
  return http.post('/issue/assignee-recommend', data, { showError: false });
};

/**
 * 获取指派人推荐列表
 * @param {Object} data
 * @param {Number} data.sprintId
 * @param {Number} data.projectId
 * @returns {Promise<*>}
 */
export const getRiskWarningList = async data => {
  return http.post('/kanban/risk-warning', data);
};

/**
 * 新增成员总点数超量预警忽略记录
 * @param {Object} data
 * @param {Number} data.assigneeId
 * @param {Number} data.sprintId
 * @returns {Promise<*>}
 */
export const ignoreRiskWarningPerson = async data => {
  return http.post('/issue-warning-ignore/add-assignee-estimate-point', data);
};

/**
 * 新增工作事项延期预警忽略记录
 * @param {Object} data
 * @param {Number} data.sprintId
 * @param {Number} data.issueId
 * @returns {Promise<*>}
 */
export const ignoreRiskWarningIssueList = async data => {
  return http.post('/issue-warning-ignore/add-issue-due', data);
};

/**
 * 新增迭代总点数超量预警忽略记录
 * @param {Object} data
 * @param {Number} data.sprintId
 * @returns {Promise<*>}
 */
export const ignoreRiskWarningTotal = async data => {
  return http.post('/issue-warning-ignore/add-sprint-estimate-point', data);
};

/**
 * 新增迭代总点数超量预警忽略记录
 * @param {Object} data
 * @param {Number} data.sprintId
 * @param {Number} data.toSprintId
 * @returns {Promise<*>}
 */
export const removeSprint = async data => {
  return http.post('/sprint/remove', data);
};

/**
 * 获取迭代工作变更日志
 * @returns {Promise<*>}
 */
export const getIssueLogs = async id => {
  return http.post('/kanban/sprint-issue-logs', id, {
    headers: {
      ['Content-Type']: 'application/json'
    }
  });
};

/**
 * 获取迭代工作变更日志及图表数据
 * @returns {Promise<*>}
 */
export const getIssueLogsAndChart = async id => {
  return http.post('/kanban/sprint-issue-log-statistics', id, {
    headers: {
      ['Content-Type']: 'application/json'
    }
  });
};

/**
 * 获取迭代变更日志
 * @returns {Promise<*>}
 */
export const getIterativeLogs = async id => {
  return http.post('/kanban/sprint-logs', id, {
    headers: {
      ['Content-Type']: 'application/json'
    }
  });
};

// 清空列
export const clearColumnIssue = async data => {
  return http.post('/issue/issue-column-clear', data);
};

// 更新工作流状态
export async function updateWorkflowState(data) {
  return http.post('/workflow/update-state', data);
}

export async function addTrans(data, options) {
  return http.post('/workflow/add-transition', data, options);
}

export async function deleteTrans(data) {
  return http.post('/workflow/delete-transition', data);
}

export async function validateCanStateDelete(data) {
  return http.post('/workflow/validate-state', data);
}

export async function deleteUnuseState(data) {
  return http.post('/workflow/delete-state', data);
}

// 统计时间区间工作日数量
export const countWorkday_api = async data => {
  return http.post('/org-holiday/count-workday', data);
};

// 新增 widget
export async function sysHomeWidget(data) {
  return http.post('/sys-home/add/kanban-widget', data);
}

// 新增仪表盘
export async function sysHomeAdd(data) {
  return http.post('/sys-home/add', data);
}

// 获取可以添加看板组件的仪表盘列表
export async function sysHomeGetCanAddKanbanHome() {
  return http.post('/sys-home/get/can-add-kanban-home');
}

// 指定项目获取看板组件筛选条件
export const getProjectKanbanConfig = async (data) => {
  return http.post('sys-home/get/project-kanban-config', data);
};

export const getDefaultKanbanConfig = async () => {
  return http.post('/kanban-grid/default-kanban-widget-assemble', {});
};

/**
 * 获取工作台看版组件聚合接口数据
 * @param data
 * @returns {Promise<*>}
 */
export const getKanbanWidgetAssembleInfo = async (data) => {
  return http.post('/kanban-grid/kanban-widget-assemble', data);
};


/**
 * 获取推荐的事项类型
 * @param data
 * @returns {Promise<*>}
 */
export const getRecommendIssueTypeId = async (data) => {
  return http.post('/issue/query-recommend-issue-type-id', data);
};
/**
 * 删除子任务
 * @param issueId 事项ID
 * @param subTaskId 子任务ID
 * @returns {Promise<*>}
 */
export const removeSubtask = async (issueId, subTaskId) => {
  return http.post('/issue/remove-subtask', { issueId, subTaskId });
};
/**
 * 新建子任务
 * @param data 子任务数据
 * @returns {Promise<*>}
 */
export const addSubtask = async (data) => {
  return http.post('/issue/add-subtask', data);
};

/**
 * 获取项目组成员
 * @param data 子任务数据
 * @returns {Promise<*>}
 */
export const getProjectUsers = async (data) => {
  return http.post('/member/project-users', data);
};
/**
 * 获取指派人推荐列表的点数
 * @param data
 * @returns {Promise<*>}
 */
export const getAssigneeRecommendListPoint = async data => {
  return http.post('/issue/query-assignees-estimate-point-v2', data, { showError: false });
};
